export function transformExternalSongs(rawResults: any[]) {
    return rawResults.map(({ data }) => {
        const source = data.uri.split(':')[0] || 'unknown';
        const firstArtist = data.artists?.items?.[0]?.profile?.name || 'Unknown Artist';
        const album = data.albumOfTrack?.name || null;
        const songArt = data.albumOfTrack?.coverArt?.sources?.[0]?.url || null;
        const file_url = data.albumOfTrack?.sharingInfo?.shareUrl || null;

        return {
            uuid: data.id,
            external_id: data.id,
            source, // ✅ inferred from uri
            title: data.name,
            artist: firstArtist,
            album,
            genre: 'NONE',
            song_art: songArt,
            file_url,
            duration: Math.floor(data.duration?.totalMilliseconds / 1000) || 0,
            from_search: true,
        };
    });
}